import { FormAPI } from '@philips-emr/tws-components';
import Controller, { OnMount, OnSubmit } from '@philips-emr/tws-core/lib/client';
import { MountEvent } from '@philips-emr/tws-core/lib/component/types';

import { FormTechnicalVisitAliases as Alias, FragmentNames } from '../../codegen';
import BaseController from '../BaseController';

import { handleSubmitSimple } from './technical-form-utils';

@Controller({ fragment: FragmentNames.FORM_TECHNICAL_VISIT })
export default class FormTechnicalVisitController extends BaseController {

  @OnMount(Alias.HPMS_FORM_TECHNICAL_VISIT)
  public onMount(event: MountEvent): void {
    const api = event.target as FormAPI;
    api.setEditing(true);
  }

  @OnSubmit(Alias.HPMS_FORM_TECHNICAL_VISIT)
  public onSubmitForm(event: FormAPI): void {
    const { nrSeqVisit } = this.historyService.getCurrentRouteParams();
    handleSubmitSimple(event, nrSeqVisit);
  }
}
